export default __webpack_public_path__ + "static/media/Knockout-34.7e051c7e.woff";